import "../scss/app.scss";
function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}
function setCookie(cname, cvalue, exdays, exInMs = false) {
	var d = new Date();
	if (exInMs) {
		d.setTime(d.getTime() + exdays);
	} else {
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	}
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
jQuery(document).ready(function ($) {
	$(".lazy").Lazy();
	if ($(".js-n-hero-slider").length) {
		$(".js-n-hero-slider").slick({
			arrows: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 1000,
			adaptiveHeight: true,
			prevArrow: $(".h__hero__prev"),
			nextArrow: $(".h__hero__next"),
		});
		$(".js-n-hero-slider").on(
			"beforeChange",
			(event, slick, currentSlide, nextSlide) => {
				$(".js-n-hero-slide-current").text(nextSlide + 1);
			}
		);
	}
	if ($(".js-n-sponsors-slider").length) {
		$(".js-n-sponsors-slider").slick({
			arrows: true,
			lazyLoad: "ondemand",
			dots: false,
			slidesToScroll: 4,
			slidesToShow: 4,
			autoplay: true,
			autoplaySpeed: 3000,
			prevArrow: $(".n__sponsors__slider__prev"),
			nextArrow: $(".n__sponsors__slider__next"),
		});
		$(".js-n-sponsors-slider-mobile").slick({
			arrows: true,
			lazyLoad: "ondemand",
			dots: false,
			slidesToShow: 2,
			slidesToScroll: 2,
			autoplay: true,
			autoplaySpeed: 3000,
			prevArrow: $(".n__sponsors__slider__prev--mobile"),
			nextArrow: $(".n__sponsors__slider__next--mobile"),
		});
		$(".js-n-sponsors-slider-mobile").on(
			"beforeChange",
			(event, slick, currentSlide, nextSlide) => {
				$(".js-n-sponsors-slider-counter").text(nextSlide / 2 + 1);
			}
		);
	}
	$(window).on("scroll", () => {
		if (
			document.body.scrollTop > 140 ||
			document.documentElement.scrollTop > 140
		) {
			$(".js-n-header-inner").addClass("n__header__inner--schrinked");
			$(".js-n-header").addClass("n__header--shrinked");
		} else {
			$(".js-n-header-inner").removeClass("n__header__inner--schrinked");
			$(".js-n-header").removeClass("n__header--shrinked");
		}
	});

	if (
		document.body.scrollTop > 140 ||
		document.documentElement.scrollTop > 140
	) {
		$(".js-n-header-inner").addClass("n__header__inner--schrinked");
		$(".js-n-header").addClass("n__header--shrinked");
	}

	function toggleMobileNav() {
		$(".js-n-header-panel").toggleClass("n__header__panel--opened");
	}

	document.addEventListener(
		"click",
		function (event) {
			if (event.target.closest(".n__header__panel--opened")) return;
			if (!$(".js-n-header-panel").hasClass("n__header__panel--opened")) return;
			toggleMobileNav();
		},
		false
	);

	$(".js-n-header-nav-toggle").click((e) => {
		e.preventDefault();
		e.stopPropagation();
		toggleMobileNav();
	});
	$(".js-n-header-panel .menu-item-has-children > a").click(function (e) {
		if ($(window).width() < 1450) {
			e.preventDefault();
			$(this).parent().find(".sub-menu").addClass("n__header__sub__opened");
			$(".js-n-header-panel-sub-title").text($(this).text());
		}
	});
	$(".js-n-header-panel-sub-btn").click((e) => {
		e.preventDefault();
		e.stopPropagation();
		if ($(".js-n-header-panel-sub-title").text()) {
			$(".n__header__sub__opened").removeClass("n__header__sub__opened");
			$(".js-n-header-panel-sub-title").text("");
		} else {
			toggleMobileNav();
		}
	});
	if ($(window).width() < 768 && $(".js-n-home-posts-slider").length) {
		$(".js-info-blocks-slider").slick({
			dots: false,
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: true,
			slide: ".n__info__block--slide",
		});
		$(".js-n-home-posts-slider").slick({
			dots: false,
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: true,
		});
		$(".js-n-home-posts-slider").on("beforeChange", () => {
			window.scrollTo(window.scrollX, window.scrollY - 1);
			window.scrollTo(window.scrollX, window.scrollY + 1);
		});
	}
	if ($(".js-n-home-posts-slider").length) {
		var resizeCB = debounce(function () {
			if ($(window).width() < 768) {
				$(".js-info-blocks-slider").slick({
					dots: false,
					arrows: false,
					infinite: false,
					slidesToShow: 1,
					centerMode: false,
					variableWidth: true,
				});
				$(".js-n-home-posts-slider").slick({
					dots: false,
					arrows: false,
					infinite: false,
					slidesToShow: 1,
					centerMode: false,
					variableWidth: true,
				});
				$(".js-n-home-posts-slider").on("beforeChange", () => {
					window.scrollTo(window.scrollX, window.scrollY - 1);
					window.scrollTo(window.scrollX, window.scrollY + 1);
				});
			} else {
				try {
					$(".js-info-blocks-slider").slick("unslick");
					$(".js-n-home-posts-slider").slick("unslick");
				} catch (err) {}
			}
		}, 300);

		window.addEventListener("resize", resizeCB);
	}

	$(".js-n-sponsors-nav-item, .js-n-exhibitions-nav-item").click(function (e) {
		e.preventDefault();
		const isMobile = $(window).width() < 768;
		const offset = isMobile ? 130 : $(this).parent().innerHeight() + 80;
		const href = $(this).attr("href");
		$("html, body").animate({ scrollTop: $(href).offset().top - offset }, 700);
		setTimeout(() => {
			$("html, body").animate(
				{ scrollTop: $(href).offset().top - offset },
				700
			);
		}, 1000);
		window.location.hash = href;
		if (isMobile) {
			$(this).parents(".js-inner-menu-nav").slideToggle();
			$(".js-inner-menu-nav-toggle").removeClass("opened");
		}
	});

	if (window.location.hash.length !== 0) {
		if ($(window.location.hash).length) {
			const offset = $(".n__inner__menu").innerHeight() + 80;
			$("html, body").animate(
				{ scrollTop: $(window.location.hash).offset().top - offset },
				0
			);
			setTimeout(() => {
				$("html, body").animate(
					{ scrollTop: $(window.location.hash).offset().top - offset },
					700
				);
			}, 1500);
		}
	}

	$(".js-n-back-top").click(function (e) {
		e.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, 700);
	});

	$(".js-team-volunteers > ul").addClass("row n__team__row");
	$(".js-team-volunteers > ul > li").addClass(
		"col-xs-12 col-sm-4 col-md-3 col-2 n__team__member__text"
	);

	if ($(".js-n-text-slider").length) {
		$(".js-n-text-slider").slick({
			arrows: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: $(".js-n-text-slider-prev"),
			nextArrow: $(".js-n-text-slider-next"),
			adaptiveHeight: true,
			lazyLoad: "ondemand",
		});
		$(".js-n-text-slider").on(
			"beforeChange",
			(event, slick, currentSlide, nextSlide) => {
				$(".js-n-text-slider-current").text(nextSlide + 1);
			}
		);
	}

	if ($(".js-images-slider").length) {
		$(".js-images-slider").slick({
			arrows: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: $(".js-images-slider-prev"),
			nextArrow: $(".js-images-slider-next"),
			adaptiveHeight: true,
			lazyLoad: "progressive",
		});
		$(".js-images-slider").on(
			"beforeChange",
			(event, slick, currentSlide, nextSlide) => {
				$(".js-images-slider-current").text(nextSlide + 1);
			}
		);
	}

	if ($(".js-similar-events-slider").length) {
		$(".js-similar-events-slider").slick({
			arrows: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			prevArrow: $(".js-similar-events-slider-prev"),
			nextArrow: $(".js-similar-events-slider-next"),
			adaptiveHeight: true,
			lazyLoad: "ondemand",
		});
		$(".js-similar-events-slider").on(
			"beforeChange",
			(event, slick, currentSlide, nextSlide) => {
				$(".js-similar-events-slider-current").text(nextSlide + 1);
				window.scrollTo(window.scrollX, window.scrollY - 1);
				window.scrollTo(window.scrollX, window.scrollY + 1);
			}
		);
	}

	$(".js-faq-item-header").click(function (e) {
		$(this).parent().toggleClass("opened");
	});

	if (typeof WOW !== "undefined") {
		new WOW().init();
	}

	$(".js-inner-menu-nav-toggle").click(function (e) {
		e.preventDefault();
		if ($(window).width() < 768) {
			$(".js-inner-menu-nav").slideToggle();
			$(this).toggleClass("opened");
		}
	});

	$(".js-cookie-bar-btn").click(function (e) {
		e.preventDefault();
		setCookie("cookies-accepted", 1, 365);
		$(".js-cookie-bar").remove();
	});

	$(".js-promo-btn").on("click", function (e) {
		e.preventDefault();
		setCookie("promo-closed", 1, 1000 * 60 * 20, true);
		$(".js-promo-bar").remove();
	});
	if (typeof $().marquee !== "undefined") {
		$(".js-marquee").marquee({
			pauseOnHover: true,
		});
	}

	require("./exhibitions");
	require("./calendar");
	require("./quizes");
	require("./newsletter");
	require("./map");
	require("./donations");
	// End of document ready
});
